export default "__VITE_ASSET__CnSr8$Xr__"